import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import { DefaultColumnRequest } from './requests/default-columns.request';
import { DefaultColumnResponse } from './responses/default-columns.response';
import IService from '@types_main/iservice';
import { PagedResponse } from '@types_main/paged-response';
import { PagedParams } from '@types_main/paged.params';

export class DefaultColumnService extends BaseService implements IService<DefaultColumnResponse> {
    protected get resourceName(): string {
        return 'crm/default-columns';
    }

    public async getAll(
        filter?: string,
        params?: PagedParams
    ): Promise<AxiosResponse<PagedResponse<DefaultColumnResponse>>> {
        return await this.get<PagedResponse<DefaultColumnResponse>>('paginated' + (filter ?? ''), params);
    }

    public async getOrdered(): Promise<AxiosResponse<{ data: DefaultColumnResponse[] }>> {
        return await this.get('');
    }

    public async getById(id: string): Promise<AxiosResponse<{ data: DefaultColumnResponse }>> {
        return await this.get(id);
    }

    public async create(body: DefaultColumnRequest): Promise<AxiosResponse<{ data: DefaultColumnResponse }>> {
        return await this.post(body);
    }

    public async update(id: string, body: DefaultColumnRequest): Promise<AxiosResponse<{ data: DefaultColumnResponse }>> {
        return await this.put(id, body);
    }

    public async reorder(orderedIds: string[]): Promise<AxiosResponse<void>> {
        return await this.patch('reorder', { orderedIds });
    }

    public async deleteById(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(id);
    }
}
